import WorkflowEdge from "./WorkflowEdge";

export const edgeTypes = {
  workflowEdge: WorkflowEdge,
};

export { WorkflowEdge };
